/**
 * Dynamic annex-cell renderer: a 1/2/3 score badge (prototype line 3731) or a
 * free-form value, with a placeholder when the value is absent for this row.
 *
 * `kind="score"` → colored 1/2/3 badge (1 = definitely no → error-muted,
 * 2 = maybe → warning-muted, 3 = definitely yes → accent-muted), mirroring the
 * footer legend. `kind="value"` → plain text. Missing → placeholder. The score
 * scale + colors are translated from the prototype hex to design-system tokens.
 */

const SCORE_CLASS: Record<number, string> = {
  1: "bg-error-muted text-error border-border",
  2: "bg-warning-muted text-warning border-border",
  3: "bg-accent-muted text-accent border-border",
};

export function ScoreBadge({
  value,
  kind,
}: {
  value: string | number | null | undefined;
  kind: "score" | "value";
}) {
  if (value == null || value === "") {
    return (
      <span data-testid="annex-placeholder" className="text-text-muted">
        —
      </span>
    );
  }

  if (kind === "score") {
    const score = Number(value);
    const cls = SCORE_CLASS[score] ?? "bg-surface text-text-secondary border-border";
    return (
      <span
        data-testid="score-badge"
        data-score={score}
        className={`inline-flex h-6 w-6 items-center justify-center rounded-md border text-caption ${cls}`}
      >
        {score}
      </span>
    );
  }

  return (
    <span data-testid="annex-value" className="text-body text-text-secondary">
      {String(value)}
    </span>
  );
}
